import React from 'react';
import LocationTemplate from './LocationTemplate';

const RodanthePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Rodanthe"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27968"]}
      latitude={35.4318}
      longitude={-75.4621}
      population={261}
      historicalFact="Name derived from 'Roanoke' and 'anthe' (flower), featured in Nicholas Sparks' novel 'Nights in Rodanthe.'"
      nearbyTowns={[
        "Waves, NC",
        "Salvo, NC",
        "Chicamacomico, NC",
        "Pea Island, NC",
        "Avon, NC",
        "Nags Head, NC",
        "Oregon Inlet, NC",
        "Manteo, NC"
      ]}
    />
  );
};

export default RodanthePage;